module.exports = __webpack_public_path__ + "img/xroad7_large.6b76236f.svg";